import { useEffect } from 'react';

const useMetaTag = (key, value, isProperty) => {
  useEffect(() => {
    // react-helmet does not prepend so need to do it manually
    if (key && value) {
      const meta = document.createElement('meta');
      meta.setAttribute(isProperty ? 'property' : 'name', key);
      meta.setAttribute('content', value);
      const head = document.querySelector('head');
      head?.insertBefore(meta, head.firstChild);
    }
  }, [value]);
};

export default useMetaTag;
